module.exports = __webpack_public_path__ + "img/Malta.8810cf73.png";